/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

import axios from "axios";
import baseUrl from "..";
import { authToken, authUserID, axiosInstance } from "../axiosConfig";

const listRawMaterialType = async (page : any, pageSize: any, sort: string, order: string, x_auth_token: string, x_user_id: string , keyword:string) => {
    try {
      const headers = {
        'x-auth-token': authToken,
        'x-userid': authUserID,
      };
      const response = await axiosInstance.get(`${baseUrl}/master/list_all_raw_material_type?page=${page}&size=${pageSize}&sort=${sort}&status=&order=${order}&keyword=${keyword}`, { headers });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

  const listDropDownType = async (x_auth_token: string, x_user_id: string) => {
    try {
      const headers = {
        'x-auth-token': authToken,
        'x-userid': authUserID,
      };
      const response = await axiosInstance.get(`${baseUrl}/master/list_all_raw_material_type?sort=material_type&status=active&order=asc`, { headers });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

const listRawMaterialSubType = async (page : any, pageSize: any, sort: string, order: string, x_auth_token: string, x_user_id: string, keyword:string, material_id:string) => {
    try {
      const headers = {
        'x-auth-token': authToken,
        'x-userid': authUserID,
      };
      const response = await axiosInstance.get(`${baseUrl}/master/list_all_raw_material_sub_type?page=${page}&size=${pageSize}&sort=${sort}&order=${order}&status=&material_type_id=${material_id}&keyword=${keyword}`, { headers });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

const createRawMaterialType = async (dataToSend: any, x_auth_token: string, x_user_id: string) => {
    try {
      const headers = {
        'x-auth-token': x_auth_token,
        'x-userid': x_user_id,
      };
      const response = await axiosInstance.post(`${baseUrl}/raw_material/create_material_type`, dataToSend, { headers });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }


const createRawMaterialSubType = async (dataToSend: any, x_auth_token: string, x_user_id: string) => {
    try {
      const headers = {
        'x-auth-token': x_auth_token,
        'x-userid': x_user_id,
      };
      const response = await axiosInstance.post(`${baseUrl}/raw_material/create_material_sub_type`, dataToSend, { headers });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
    }
  }

const changeTypeStatus = async (id: string, status: string, x_auth_token: string, x_user_id: string , interface_name : string) => {
    try {
        const headers = {
          'x-auth-token': x_auth_token,
          'x-userid': x_user_id,
        };
        const response = await axiosInstance.post(`${baseUrl}/raw_material/change_type_status`, {
            id: id,
            status: status,
            interface_name: interface_name
        }, { headers });
        return response.data;
      } catch (error) {
        if (axios.isAxiosError(error)) {
          return error.response?.data
        }
    }
}

const changeSubTypeStatus = async (id: string, status: string, x_auth_token: string, x_user_id: string, interface_name : string) => {
  try {
      const headers = {
        'x-auth-token': x_auth_token,
        'x-userid': x_user_id,
      };
      const response = await axiosInstance.post(`${baseUrl}/raw_material/change_sub_type_status`, {
          id: id,
          status: status,
          interface_name: interface_name
      }, { headers });
      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        return error.response?.data
      }
  }
}




const rawMaterials = {
    listRawMaterialType,
    createRawMaterialType,
    createRawMaterialSubType,
    changeTypeStatus,
    listRawMaterialSubType,
    changeSubTypeStatus,
    listDropDownType
  };
  
  
export { rawMaterials };